"use client";

/** Close button for the docs popup window. Hidden when not opened as a popup. */
import { useEffect, useState } from "react";

export default function CloseWindowButton() {
    const [isPopup, setIsPopup] = useState(false);

    useEffect(() => {
        setIsPopup(Boolean(window.opener));
    }, []);

    if (!isPopup) return null;

    return (
        <button
            onClick={() => window.close()}
            aria-label="Close documentation"
            className="p-2 rounded-full bg-slate-800/90 border border-white/10 text-gray-300 hover:text-white hover:bg-slate-700 transition-colors"
        >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
    );
}
